import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Logo from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatApiError(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return "Accesso non riuscito. Riprova.";
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-bone flex flex-col items-center justify-center px-6">
      <div className="grain-overlay" aria-hidden="true" />
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <Logo />
        </div>
        <form
          data-testid="admin-login-form"
          onSubmit={submit}
          className="bg-paper border border-pine/10 rounded-md p-8 lg:p-10"
        >
          <h1 className="font-serif text-2xl text-pine tracking-tight">Area riservata</h1>
          <p className="text-sm text-moss mt-2">Accedi per gestire le richieste di prenotazione.</p>
          <label className="block mt-8">
            <span className="text-xs font-semibold uppercase tracking-[0.16em] text-moss">Email</span>
            <input
              data-testid="admin-login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-transparent border border-pine/20 rounded-md focus:border-terracotta outline-none py-3 px-4 text-pine transition-colors duration-300"
            />
          </label>
          <label className="block mt-5">
            <span className="text-xs font-semibold uppercase tracking-[0.16em] text-moss">Password</span>
            <input
              data-testid="admin-login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-transparent border border-pine/20 rounded-md focus:border-terracotta outline-none py-3 px-4 text-pine transition-colors duration-300"
            />
          </label>
          {error && (
            <p data-testid="admin-login-error" className="mt-4 text-sm text-terracotta">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="mt-8 w-full rounded-full bg-pine text-bone font-semibold py-3.5 hover:bg-terracotta disabled:opacity-60 transition-colors duration-300"
          >
            {loading ? "Accesso in corso..." : "Accedi"}
          </button>
        </form>
        <p className="text-center mt-6">
          <Link to="/" data-testid="back-to-site-link" className="text-xs uppercase tracking-[0.16em] text-moss hover:text-terracotta transition-colors duration-300">
            ← Torna al sito
          </Link>
        </p>
      </div>
    </div>
  );
}
